import React, { Component } from 'react'
import $ from 'jquery'
import { connect } from 'react-redux'
import geolib from 'geolib'
import Spinner from 'react-md-spinner'
import CommentsDashboard from '../../components/comments/CommentsDashboard.jsx'

import { fetchVisit } from '../../redux/actions/visits.js'
import { fetchAccounts } from '../../redux/actions/accounts.js'
import { fetchUsers, fetchCurrentUser } from '../../redux/actions/users.js'


class VisitShowView extends Component {
  constructor(props) {
    super(props)

    const { match } = this.props
    this.state = { visitId: match.params.id, account_id: null, account: null, currentPosition: null }
  }

  componentDidMount() {
    const { visitId } = this.state
    const { dispatch }  = this.props

    dispatch(fetchAccounts('quick'))
    dispatch(fetchUsers('quick'))
    dispatch(fetchVisit(visitId))
    dispatch(fetchCurrentUser())
    navigator.geolocation.getCurrentPosition(position => {
      console.log(position);
      this.setState({ currentPosition: position.coords })
    })
  }

  componentDidUpdate() {
    $(document).foundation('dropdown', 'reflow')
  }

  render() {
    const { currentPosition } = this.state
    const { visit } = this.props

    if (visit && visit.id && currentPosition && currentPosition.longitude && currentPosition.latitude) {
      const { account } = visit
      const { address } = account
      return (

        <div>
          <br />
          <div className="row">
            <div className="small-10 columns">
              <h3 className="subheader">Visit Show</h3>
            </div>
            <div className="small-2 columns">
              <button className="button tiny right dropdown" data-dropdown="drop1">Actions</button>
              <ul id="drop1" className="f-dropdown" data-dropdown-content="">
                <li>
                  <a href={`/visits/${visit.id}/edit`}>Edit Visit</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="small-12 columns">
              <label>Account
                <input value={visit.account.name} readOnly name="account" />
              </label>
            </div>
          </div>
          <div className="row">
            <div className="small-6 columns">
              <label>Account Sales Person
                <input value={visit.salesperson.name} readOnly name="salesperson" />
              </label>
            </div>
            <div className="small-6 columns">
              <label>Visit Logged By
                <input value={visit.visitor.name} readOnly name="visitor" />
              </label>
            </div>
          </div>
          <div className="row">
            { visit.id && <DistanceLongLatComponent location={address} long={visit.longitude} lat={visit.latitude} /> }
          </div>
          <div className="row">
            <div className="small-12 columns">
              <div className="content active" id="comments">
                {<CommentsDashboard commentableType='visit' commentableId={visit.id} readOnly={true} />}
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div className="row">
            <div className="small-12 columns">
              <h3 className="subheader">Visit Show</h3>
              <Spinner />
            </div>
          </div>
        </div>
      )
    }
  }

}

const mapStateToProps = (state, props) => {
  const { visit } = state.visits.current
  return {
    visit
  }
}

const connectedVisitShowView = connect(mapStateToProps,)(VisitShowView)
export default connectedVisitShowView


const DistanceLongLatComponent = ({ long, lat, location }) => {

  if (!long || !lat || !location) return null

  const distance = geolib.getDistance({latitude: lat, longitude: long}, {latitude: location.latitude, longitude: location.longitude}, {unit: 'ft'})

  return (
    <section>
      <div className="small-4 columns">
        <label>Longitude
        <input readOnly type="text" value={long} />
        </label>
      </div>
      <div className="small-4 columns">
        <label>Latitude
        <input readOnly type="text" value={lat} />
        </label>
      </div>
      <div className="small-4 columns">
        <label>Distance
        <input readOnly type="text" value={distance} />
        </label>
      </div>
    </section>
  )
}
